'use client';

import Link from 'next/link';
import { legalConfig } from '@/lib/legal';
import { strings } from '@/content/strings';

export default function NoticeAtCollection() {
  const categories = legalConfig.dataCategories.map((entry) => entry.category).join(', ');

  return (
    <div className="rounded-lg border border-border bg-ghost px-3 py-2 text-xs text-foreground space-y-1">
      <div className="font-semibold text-foreground">{strings.common.notice.title}</div>
      <div className="text-muted-foreground">
        {strings.common.notice.summary(categories)}
      </div>
      <div className="text-muted-foreground">
        {strings.common.notice.reviewPrefix}{' '}
        <Link href="/notice-at-collection" className="text-primary hover:opacity-80">
          {strings.common.notice.noticeLink}
        </Link>{' '}
        {strings.common.notice.and}{' '}
        <Link href="/privacy" className="text-primary hover:opacity-80">
          {strings.common.notice.privacyLink}
        </Link>
        .
      </div>
    </div>
  );
}
